import { SidebarIcon } from '../components/SidebarIcon';
import './PortalSectionLayout.css';
import './PortalSectionInteractions.css';
import './DocumentsPage.css';

const patientInformationPdf = `${process.env.PUBLIC_URL}/patient-documents/prgf-endoret-patienteninformation.pdf`;

export function DocumentsPage() {
  return (
    <div className="portal-section-page portal-section-page--documents portal-page-surface">
      <div className="portal-page-content">
        <header className="portal-page-heading">
          <h1 className="text-3xl font-semibold text-slate-900">Meine Dokumente</h1>
          <p>Hier finden Sie wichtige Informationen und Dokumente Ihrer Praxis.</p>
        </header>

        <section className="portal-section-card portal-documents__card" aria-labelledby="prgf-document-title">
          <div className="portal-documents__information">
            <span className="portal-documents__pdf-icon" aria-hidden="true">
              <SidebarIcon name="document" />
              <span>PDF</span>
            </span>
            <div className="portal-documents__copy">
              <h2 id="prgf-document-title">PRGF-Endoret – Eigenbluttherapie</h2>
              <p>Patienteninformation zur Eigenbluttherapie mit körpereigenen Wachstumsfaktoren in der Zahnmedizin.</p>
              <p className="portal-documents__metadata">PDF · 12 Seiten</p>
            </div>
          </div>

          <div className="portal-documents__actions">
            <a
              href={patientInformationPdf}
              target="_blank"
              rel="noopener noreferrer"
              className="portal-section-action--gold"
            >
              Ansehen<span className="sr-only"> (PDF in neuem Tab öffnen)</span>
            </a>
            <a
              href={patientInformationPdf}
              download="PRGF-Endoret-Patienteninformation.pdf"
              className="portal-section-action--neutral"
            >
              Herunterladen
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}
